const ITEMS = [
  "Building Bridges",
  "Elevating Communities",
  "Transforming Leaders",
  "Academic Excellence",
  "Systemic Shift",
  "Mentorship",
  "B.E.T with AB Hunter",
];

function Row() {
  return (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-display text-xl font-medium italic tracking-wide text-gold/90 sm:text-2xl">
            {item}
          </span>
          <svg viewBox="0 0 10 10" className="h-2.5 w-2.5 fill-gold/50" aria-hidden>
            <rect x="1.5" y="1.5" width="7" height="7" transform="rotate(45 5 5)" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-gold/15 bg-ink-card/60 py-5">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
    </div>
  );
}
